import { BaseDto } from '@/shared/dtos/base-dto';

export class etiqueta extends BaseDto {
    public nombre !: string;
    public id_tipoetiqueta !: number;
    public id_nutricionista !: number;
    public sistema !: boolean;

 } 
